module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy Y White.07f3b4c2.png";